/* eslint-disable camelcase */
import { Vue, Component } from 'vue-property-decorator'
import { SupportedFileType } from '@/shared/models/common.models'
import { AxiosResponse } from 'axios'
import { FileUtils } from '@/shared/util/file-utils'
import { CommonOpenFileParams } from '@/api/resources/common/shared/models/common.models'

@Component
export class FileMixin extends Vue {
    $_openFile(commonOpenFileParams: CommonOpenFileParams): void {
        FileUtils.openFile(commonOpenFileParams)
    }

    $_downloadFile(blob: Blob, filename: string, type: SupportedFileType): void {
        FileUtils.downloadFile(blob, filename, type)
    }

    $_getFilenameFromHeaderRequest(axiosResponse: AxiosResponse): string {
        return FileUtils.getFilenameFromHeaderRequest(axiosResponse)
    }
}
